export { default } from './UnderstandingDraftsModal';
